import {
  mapState,
  mapMutations
} from 'vuex'
import api from '../service/services.js'
import moment from 'moment'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'

export default {
  data () {
    return {
      date: moment(new Date()).format('YYYY-MM-DD'),
      isLoading: false,
      screenHeight: window.innerHeight - 225,
      storage_data: [],
      per_use: 0,
      per_free: 100
    }
  },
  computed: {
    ...mapState(['user', 'url']),
    ...mapMutations(['checkLogin'])
  },
  components: {
    Loading
  },
  methods: {
    getData () {
      api.getStorage(this.url, result => {
        if (result.status === 1) {
          this.storage_data = result.data
          this.per_use = Math.round(this.storage_data.per_use)
          this.per_free = 100 - this.per_use
        } else {
          swal.fire(
            'Error 500',
            'การดึงข้อมูลอีเมลมีปัญหา!! ' + result.data,
            'error'
          )
        }
        this.isLoading = false
      }, error => {
        this.isLoading = false
        alert(JSON.stringify(error))
      })
    },
    dateFormat (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    CStore () {
      swal.fire({
        title: 'การเคลียข้อมูลใน Droplet',
        text: 'ท่านต้องการลบข้อมูลของวันที่ ' + this.dateFormat(this.date),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((res) => {
        if (res.value) {
          api.clearStorage(this.url, {
            date: this.date
          },
          result => {
            if (result.status === 1) {
              swal.fire(
                'Good Job!',
                result.data,
                'success'
              )
              this.getData()
            } else {
              swal.fire(
                'Error 500',
                'การดึงข้อมูลอีเมลมีปัญหา!! ' + result.data,
                'error'
              )
            }
          },
          error => {
            alert(JSON.stringify(error))
          }
          )
        }
      })
    }
  },
  mounted () {
    this.isLoading = true
    this.getData()
    setInterval(() => {
      this.getData()
    }, 1000)
    try {
      this.checkLogin()
    } catch (e) {
      // location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/storage.js